import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { ImportExportIcon } from './../../../themes/icons';
import { Loading } from './../../../components/includes/loading';
import { Section, Content, Main, Buttons } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Table, Thead, Tbody, Row, Cell, Tresponsive, Ttolbar } from './../../../components/includes/ui/table';
import { Btn, Link, Label } from './../../../components/includes/ui';
import { FormatDate } from './../../../utilities/date';
import { isUndefined, isSorting, isStatus } from './../../../utilities/utils';
import { PollService } from './../../../services';
import Confirm from './../../shared/confirm';
import PollImport from './../import';

import API from './../../../config/api';

const rows = [
  { id: 'name', sort: false, numeric: false, disablePadding: false, label: 'Nombre' },
  { id: 'days', sort: false, numeric: false, disablePadding: false, label: 'Días' },
  { id: 'status', sort: false, numeric: false, disablePadding: false, label: 'Estado' },
  { id: 'created_at', sort: false, numeric: false, disablePadding: false, label: 'Creado' },
  { id: 'updated_at', sort: false, numeric: false, disablePadding: false, label: 'Editado' },
  { id: 'actions', sort: false, numeric: true, disablePadding: false, label: 'Acciones', width:160, minWidth: 160 }
];

class Polls extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      page: 0,
      order: 'asc',
      orderBy: 'name',
      entities: null,
      formImportShow: false,
      formImportId: null,
      formDeleteShow: false,
      formDeleteMessage: null
    };
  }

  componentDidMount(){

    // @Pagination
    let page = this.props.match.params.page;

    if(!isUndefined(page)){

      if(!isNaN(page) && page >= 0){

        this._Find(page);

      }else{

        this.props.history.push('/polls');

      }

    }else{

      this._Find(this.state.page);

    }

  }

  /*
  ** @Service
  ** @Description: FindAll
  */

  _Find = (page) => {

    PollService.get(page).then((response) => {

      this.setState({ loading: true, page: !isUndefined(page) ? parseInt(page,10) : 0, entities: response });

    }).catch((error) => {

      this.props.AlertShow({ open: true, variant: 'error', message: Error.internal });

    });

  }

  /*
  ** @Event
  ** @Description: Import users
  */

  handleImport = (id) => {
    this.setState({ formImportShow: true, formImportId: id });
  }

  /*
  ** @Event
  ** @Description: Close add new users to poll
  */

  handleImportCancel = () => {
    this.setState({ formImportShow: false });
  }

  /*
  ** @Event
  ** @Description: Close add new users to poll
  */

  handleImportConfirm = () => {
    this.setState({ formImportShow: false });
  }

  render() {

    const { loading, order, orderBy, entities, formImportId } = this.state;

    return (
      <Section>

        <ToolbarPrimary title="Encuestas"/>
        <BreadcrumbItem to='/polls'>Encuestas</BreadcrumbItem>

        <Content>
          <Main>

            <Confirm
               status={ this.state.formDeleteShow }
               message={ this.state.formDeleteMessage }
               cancel={ () => { this.handleConfirmDeleteCancel() } }
               confirm={ () => { this.handleConfirmDeleteConfirm() } }
            />

            <PollImport
              id={ formImportId }
              status={ this.state.formImportShow }
              cancel={ () => { this.handleImportCancel() } }
              confirm={ () => { this.handleImportConfirm() } }
            />

            <Ttolbar title="Encuestas"/>
            <Ttolbar title="Encuestas">
              <Buttons>
                <Btn color="success" aria-label="add" icon="add" component={ NavLink } to="/polls/create">
                  Crear encuesta
                </Btn>
              </Buttons>
            </Ttolbar>

            { loading ? (
              <Tresponsive>
                <Table>

                  <Thead rows={ rows } order={ order } orderBy={ orderBy } onRequestSort={ this.handleRequestSort }/>

                  <Tbody>

                    { entities.polls.length > 0 ? (

                      entities.polls.sort(isSorting(order, orderBy)).map(entity => {
                        return (
                          <Row key={ entity._id }>
                            <Cell>
                              <span>
                                <Link to={ `${ API.endpoint.web }/encuestas/${ entity.slug }/1` } isExrernal>
                                  { entity.name }
                                </Link>
                              </span>
                            </Cell>
                            <Cell>
                              <Label variant="info">
                                { entity.days }
                              </Label>
                            </Cell>
                            <Cell>
                              <Label variant={ entity.status ? "success" : "danger"}>
                                { isStatus(entity.status) }
                              </Label>
                            </Cell>
                            <Cell>
                              <FormatDate value={ entity.created_at }/>
                            </Cell>
                            <Cell>
                              <FormatDate value={ entity.updated_at }/>
                            </Cell>
                            <Cell numeric>
                              {/*
                              <Btn color="primary" size="xsmall" onClick={ () => { this.handleImport(entity._id) } }>
                                <FileCopyIcon fontSize="small"/>
                              </Btn>
                              */}
                              <Btn color="success" size="xsmall" target="_blank" href={ `${ API.endpoint.services }/poll/results/list/${ entity._id }/${ entity.key }` }>
                                <ImportExportIcon fontSize="small"/>
                              </Btn>
                              {/*
                              <Btn color="primary" size="xsmall" component={ NavLink } to={ `/polls/update/${ entity._id }` }>
                                <EditIcon fontSize="small"/>
                              </Btn>
                              <Btn color="secondary" size="xsmall" component={ NavLink } to={ `/polls/builder/${ entity._id }` }>
                                <BuildIcon fontSize="small"/>
                              </Btn>
                              */}
                            </Cell>
                          </Row>
                        );
                      })

                    ) : (

                      <Row key="1">
                        <Cell colSpan={ rows.length }>No se encontraron resultados.</Cell>
                      </Row>

                    )}

                  </Tbody>

                </Table>
              </Tresponsive>
            ) : (
              <Loading variant="primary"/>
            ) }

          </Main>
        </Content>
      </Section>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Polls);
